import { SystemLocale } from '@ninja/utilities';
import { APIFactoryOptions, getPolicyDetails } from '@shory-health-individual/customer-api';
import { JourneyDetails, AppInit } from '../../../../server';

const getNames = (journey: JourneyDetails, memberId: string) => {
	const member =
		journey.principalDetails.memberId === memberId
			? journey.principalDetails
			: journey.dependents?.find((d) => d.memberId === memberId);

	return { firstName: member?.firstName, lastName: member?.lastName };
};

export async function getPolicyDetailsServerData(
	serverDataConnection: APIFactoryOptions,
	journey: JourneyDetails,
	locale: string
) {
	const policyDetails = await getPolicyDetails(serverDataConnection)({
		parameters: { encryptedJourneyId: journey.encryptedJourneyId },
	});

	const appInit = new AppInit(locale as SystemLocale);
	const insuranceCompany = appInit.getInsuranceCompanyById(policyDetails.insuranceCompanyId);

	const policy = {
		...policyDetails,
		members: policyDetails.members.map((m) => ({
			...m,
			gender: appInit.getGenderById(m.genderId)?.name,
			relationship: appInit.getRelationshipById(m.relationshipTypeId)?.name,
			nationality: appInit.getCountryById(m.nationalityId)?.name,
			...getNames(journey, m.memberId),
		})),
		insuranceCompany: {
			logoUrl: insuranceCompany?.logoUrl,
			shortName: insuranceCompany?.shortName,
		},
		plan: appInit.getPlanById(policyDetails.planId)?.name,
	};

	return policy;
}
